import SeamApi from '../lib/seam-api';

const legacyTeamIds = {
    'start': 2,
    'invest': 3,
    'grow': 4,
    'innovate': 7,
    'programmes/launchpad': 1,
    'programmes/tech-welcome': 5,
    'programmes/business-productivity': 10,
    'programmes/rural-grant': 11,
    'programmes/low-carbon': 12,
};

const getAdminTeamMap = async () => {
    try {
        const { data } = await SeamApi.get('/api/admin-teams/programme-map', { params: {} });
        return data || {};
    } catch (error) {
        return {};
    }
};

const getAdminTeamId = async (...slugs) => {
    const adminTeamMap = await getAdminTeamMap();

    for (const slug of slugs) {
        if (!slug) continue;

        if (adminTeamMap[slug] !== undefined) {
            return adminTeamMap[slug];
        }

        if (legacyTeamIds[slug] !== undefined) {
            return legacyTeamIds[slug];
        }
    }

    return 6;
};

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('contact-us-form');

    if (form) {
        const firstName = document.getElementById('first-name');
        const lastName = document.getElementById('last-name');

        const message = document.getElementById('message');
        const email = document.getElementById('email');

        const phoneNumber = document.getElementById('phone-number');
        const error = document.getElementById('contact-us-error');

        const type = form.getAttribute('data-type');
        const mailingList = document.getElementById('mailing-list-accept');

        const disableForm = () => {
            form.classList.add('form--completed')

            Array.from(form.elements).forEach(formElement => formElement.disabled = true);
        }

        form.addEventListener('submit', async (event) => {
            let params = {
                source_distribution_id : 1,
                subject: 'Contact Us',
                contact_permissions : [],
                email: email?.value,
                first_name: firstName?.value,
                last_name: lastName?.value,
                phone_number: phoneNumber?.value,
                message: message?.value,
            };

            params.admin_team_id = await getAdminTeamId(type);

            if (mailingList?.checked === true) params.contact_permissions.push(1);

            SeamApi.contacts().message(params, (err) => {
                if (err.hasOwnProperty('email')) {
                    email.classList.toggle('border-gray-300');
                    email.classList.add('border-red-400');
                }

                error.innerText = 'There seems to have been an error';
                error.className = 'text-sm font-medium text-red-500';
             }).then(() => {
                error.innerText = 'Successfully enquired! You will hear back shortly';
                error.className = 'text-sm font-medium text-green-500';

                disableForm();
             });

            event.preventDefault();
        });
    }
});
